"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RECOMMENDATIONS_RESOURCE = exports.PILL_EMBED_CLASS = exports.PILLS_VERSIONS = exports.PILLS_V2_PATTERN = exports.PILLS_V2_BASEURL = exports.PILLS_V1_PATTERN = exports.PILLS_V1_BASEURL = exports.PILLBUILDER_VERSION = exports.MIN_HEIGHT = exports.IFRAME_ID_PREFIX = exports.IFRAME_CLASS = exports.API_KEY = exports.API_BASEURL = void 0;
var IFRAME_ID_PREFIX = 'finect-pill-';
exports.IFRAME_ID_PREFIX = IFRAME_ID_PREFIX;
var PILLBUILDER_VERSION = process.env.PACKAGE_VERSION;
exports.PILLBUILDER_VERSION = PILLBUILDER_VERSION;
var IFRAME_CLASS = 'finect-pill';
exports.IFRAME_CLASS = IFRAME_CLASS;
var PILL_EMBED_CLASS = 'finect-pill';
exports.PILL_EMBED_CLASS = PILL_EMBED_CLASS;
var PILLS_V1_PATTERN = /(https?:\/\/.*?)\/apps\/(.*?)(?:$|\/)/;
exports.PILLS_V1_PATTERN = PILLS_V1_PATTERN;
var PILLS_V2_PATTERN = /(https?:\/\/.*?)\/pills\/.+?\/.+?\/.+?\/(.*?)(?:$|\/)/;
exports.PILLS_V2_PATTERN = PILLS_V2_PATTERN;
var RECOMMENDATIONS_RESOURCE = 'v4/contents/applications/recommended';
exports.RECOMMENDATIONS_RESOURCE = RECOMMENDATIONS_RESOURCE;
var API_KEY = process.env.API_KEY;
exports.API_KEY = API_KEY;
var API_BASEURL = process.env.FINECT_API_BASEURL;
exports.API_BASEURL = API_BASEURL;
var PILLS_V1_BASEURL = process.env.PILLS_V1_BASEURL || 'https://finect.com/apps';
exports.PILLS_V1_BASEURL = PILLS_V1_BASEURL;
var PILLS_V2_BASEURL = process.env.PILLS_V2_BASEURL || 'https://www.finect.com/pills';
exports.PILLS_V2_BASEURL = PILLS_V2_BASEURL;
var MIN_HEIGHT = 500;
exports.MIN_HEIGHT = MIN_HEIGHT;
var PILLS_VERSIONS = {
  pill: 2,
  'pill-legacy': 1
};
exports.PILLS_VERSIONS = PILLS_VERSIONS;